import React, { Fragment } from "react";
import { graphql } from "react-apollo";
import { compose } from "recompose";

import withErrorState from "../hocs/withErrorState";
import withLoadingState from "../hocs/withLoadingState";
import withLocalization from "../hocs/withLocalization";
import withFlattenedTranslations from "../hocs/withFlattenedTranslations";
import withPageInfo from "../hocs/withPageInfo";
import withConnectionStatus from "../hocs/withConnectionStatus";
import withRedirectWhenEmpty from "../hocs/withRedirectWhenEmpty";

import HotspotsWithText from "../components/HotspotsWithText";
import TopicClusterTopicButton from "../components/TopicClusterTopicButton";

import Navigation from "../layouts/Navigation";

import topicClusterQuery from "../queries/topicCluster";

import infoGraphic from "../assets/images/landschaftsgrafik_man.png";
import infoGraphic2x from "../assets/images/landschaftsgrafik_man@2x.png";
import IntroSection from "../components/IntroSection";
import withGeneralTranslations from "../hocs/withGeneralTranslations";

const INFO_GRAPHIC_WIDTH = 1024;
const INFO_GRAPHIC_HEIGHT = 660;

const hotspotcConfig = {
    "emobility-klima": {
        posX: 130,
        posY: 227,
        textAlign: "right",
    },
    "emobility-topografie": {
        posX: 730,
        posY: 88,
        textAlign: "right",
    },
    "emobility-nebenverbraucher": {
        posX: 729,
        posY: 294,
        textAlign: "right",
    },
    "emobility-ladeinfrastruktur": {
        posX: 250,
        posY: 102,
        textAlign: "left",
    },
    "emobility-standzeiten": {
        posX: 784,
        posY: 195,
        textAlign: "right",
    },
    "emobility-streckenlaenge": {
        posX: 339,
        posY: 336,
        textAlign: "right",
    },
    "emobility-passagierzahl": {
        posX: 336,
        posY: 220,
        textAlign: "left",
    },
    "emobility-transport-solutions": {
        posX: 800,
        posY: 400,
        textAlign: "right",
        theme: "light",
    },
};

const TopicCluster = (props) => {
    const { topicCluster, generalTranslations } = props;
    const { slug, topicClusterHotspots, topics } = topicCluster;

    const topicsToKeep = [
        "emobility-reichweite-netzwerkplanung",
        "emobility-ladeinfrastruktur",
        "emobility-batterietechnologie",
        "emobility-service",
    ];

    const filteredTopics = topics.filter(({ slug }) => topicsToKeep.indexOf(slug) !== -1);

    const extendedHotspots = topicClusterHotspots.map((hotspot) => {
        const { posX, posY, textAlign, theme } = hotspotcConfig[hotspot.slug];
        const normX = (posX / INFO_GRAPHIC_WIDTH) * 100;
        const normY = (posY / INFO_GRAPHIC_HEIGHT) * 100;
        return {
            ...hotspot,
            posX: normX,
            posY: normY,
            textAlign,
            theme,
        };
    });

    return (
        <Fragment>
            <Navigation />
            <IntroSection
                title="MAN Transport Solutions"
                description={generalTranslations("transport-solution-intro")}
            />
            <div style={{ background: "#fff" }}>
                <div
                    style={{
                        flex: "1 0 auto",
                        maxWidth: 1024,
                        width: "100%",
                        marginLeft: "auto",
                        marginRight: "auto",
                        paddingBottom: 40,
                    }}
                >
                    <div
                        style={{
                            position: "relative",
                            overflow: "hidden",
                            paddingTop: `${(INFO_GRAPHIC_HEIGHT / INFO_GRAPHIC_WIDTH) * 100}%`,
                        }}
                    >
                        <img
                            src={infoGraphic}
                            srcSet={`${infoGraphic2x} 2x`}
                            alt="info graphic"
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                border: 0,
                                width: "100%",
                                height: "100%",
                                userSelect: "none",
                            }}
                        />

                        <HotspotsWithText hotspots={extendedHotspots} />
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-around", paddingTop: 20 }}>
                        {filteredTopics.map((topic) => {
                            return (
                                <TopicClusterTopicButton
                                    key={topic.slug}
                                    label={topic.title}
                                    location={`/topic-cluster/${slug}/${topic.slug}`}
                                />
                            );
                        })}
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default compose(
    withConnectionStatus,
    withLocalization,
    graphql(topicClusterQuery, {
        options: ({ language, match, fetchPolicy, stage }) => ({
            variables: {
                topicClusterSlug: match.params.topicClusterSlug,
                lang: language.toLowerCase(),
                stage,
            },
            fetchPolicy,
        }),
    }),
    withErrorState,
    withLoadingState("topicCluster"),
    withRedirectWhenEmpty("topicCluster"),
    withFlattenedTranslations("topicCluster"),
    withPageInfo,
    withGeneralTranslations
)(TopicCluster);



// WEBPACK FOOTER //
// ./src/screens/TopicCluster.js